import { TFunction } from "i18next";

import { FilterField } from "~/features/filter";

export const directionsFilterFields = (t: TFunction): FilterField[] => [
  {
    name: "event",
    type: "datePicker",
    label: t("directions.actual_date_on"),
    disableFutureDates: true,
  },
];
